/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_RedeemInputs */

const en_us2_invite_redeem = /** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm invite`)
};

const pt_br2_invite_redeem = /** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar convite`)
};

const pt_pt2_invite_redeem = /** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar convite`)
};

/** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */
const es_419_invite_redeem = en_us2_invite_redeem;

/** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */
const fr_fr2_invite_redeem = en_us2_invite_redeem;

/** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */
const de_de2_invite_redeem = en_us2_invite_redeem;

/** @type {(inputs: Invite_RedeemInputs) => LocalizedString} */
const it_it2_invite_redeem = en_us2_invite_redeem;

/**
* | output |
* | --- |
* | "Confirm invite" |
*
* @param {Invite_RedeemInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeem = /** @type {((inputs?: Invite_RedeemInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_RedeemInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeem(inputs)
	if (locale === "es-419") return es_419_invite_redeem(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeem(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeem(inputs)
	if (locale === "de-DE") return de_de2_invite_redeem(inputs)
	if (locale === "it-IT") return it_it2_invite_redeem(inputs)
	return en_us2_invite_redeem(inputs)
});
export { invite_redeem as "invite.redeem" }